import { useModulesGetModuleByModuleIdQuery } from '@app/services/auto-generated/modules'

interface Accent {
  code: string
  name: string
  flag_image: string
}

interface PreferredAccentModuleConfig {
  accents: Accent[]
}

const useAccents = () => {
  const { data, isLoading, isSuccess } = useModulesGetModuleByModuleIdQuery({
    moduleId: 'PreferredAccentModule',
  })

  const languages: Accent[] = data ? (data.config as PreferredAccentModuleConfig).accents : []

  const getAccentFromCode = (languageCode: string) => {
    const target = languages.find((lng) => lng.code === languageCode)
    return target
  }

  const enhanceAccents = (accent: string | undefined | null) => {
    const acc = languages.filter((lang) => lang.code === accent)
    if (acc.length === 0) {
      return null
    }
    return acc[0]
  }

  return { languages, isLoading, getAccentFromCode, enhanceAccents, isSuccess }
}

export default useAccents
